import { BrandingResponse } from '../types/Branding.types';

export const hasExtension = (
  branding: BrandingResponse | undefined,
  extension: keyof NonNullable<BrandingResponse['extensions']>
): boolean => Object.keys(branding?.extensions ?? {}).includes(extension);
